// @ts-ignore
/* eslint-disable */
// API 更新时间：
// API 唯一标识：
import * as addressController from './addressController';
import * as analystController from './analystController';
import * as appAuthController from './appAuthController';
import * as appConfigController from './appConfigController';
import * as appCourseController from './appCourseController';
import * as appUserController from './appUserController';
import * as articleController from './articleController';
import * as articleCourseController from './articleCourseController';
import * as authController from './authController';
import * as cdAdviserController from './cdAdviserController';
import * as chatDialogController from './chatDialogController';
import * as chatRoomController from './chatRoomController';
import * as chatRoomQaController from './chatRoomQaController';
import * as chatStreamMsgController from './chatStreamMsgController';
import * as checkInController from './checkInController';
import * as clsController from './clsController';
import * as contentController from './contentController';
import * as convertController from './convertController';
import * as couponController from './couponController';
import * as couponPlanController from './couponPlanController';
import * as courseCatalogController from './courseCatalogController';
import * as courseController from './courseController';
import * as customerComplaintController from './customerComplaintController';
import * as customerStrategyController from './customerStrategyController';
import * as customerTrackController from './customerTrackController';
import * as ddOrderController from './ddOrderController';
import * as delayCouponController from './delayCouponController';
import * as eSignController from './eSignController';
import * as giftCouponController from './giftCouponController';
import * as giftGoodController from './giftGoodController';
import * as giftIntroduceController from './giftIntroduceController';
import * as invoiceController from './invoiceController';
import * as kfController from './kfController';
import * as liveRoomController from './liveRoomController';
import * as newEvaluationController from './newEvaluationController';
import * as newsController from './newsController';
import * as noticeSubController from './noticeSubController';
import * as orderController from './orderController';
import * as orderPointController from './orderPointController';
import * as ossController from './ossController';
import * as paymentController from './paymentController';
import * as pointActivityController from './pointActivityController';
import * as promotionResourceController from './promotionResourceController';
import * as promotionServiceController from './promotionServiceController';
import * as promotionStockController from './promotionStockController';
import * as promotionVideoController from './promotionVideoController';
import * as pubController from './pubController';
import * as pubTeamController from './pubTeamController';
import * as raCustomerController from './raCustomerController';
import * as recommendStockController from './recommendStockController';
import * as rewardController from './rewardController';
import * as shortVideoController from './shortVideoController';
import * as signController from './signController';
import * as skuController from './skuController';
import * as smsController from './smsController';
import * as softwarePackageController from './softwarePackageController';
import * as stockAiDiagnoseController from './stockAiDiagnoseController';
import * as stockCaseController from './stockCaseController';
import * as stockCaseNewController from './stockCaseNewController';
import * as stockInfoController from './stockInfoController';
import * as stockScoreController from './stockScoreController';
import * as strategyApplyController from './strategyApplyController';
import * as strategyBackTestController from './strategyBackTestController';
import * as strategyController from './strategyController';
import * as strategyCouponController from './strategyCouponController';
import * as strategyOrderLinkController from './strategyOrderLinkController';
import * as strategySimulateController from './strategySimulateController';
import * as strategySimulationBackTestController from './strategySimulationBackTestController';
import * as strategyStockController from './strategyStockController';
import * as streamController from './streamController';
import * as surveyController from './surveyController';
import * as teamVideoController from './teamVideoController';
import * as userController from './userController';
import * as vipCouponController from './vipCouponController';
import * as vipNoticeController from './vipNoticeController';
import * as vodController from './vodController';
import * as webOssConfigController from './webOssConfigController';
import * as weimobController from './weimobController';
import * as workWxController from './workWxController';
import * as wxController from './wxController';
import * as wxMaController from './wxMaController';
import * as wxMaNewController from './wxMaNewController';
import * as wxOauth2Controller from './wxOauth2Controller';
import * as wxTrackController from './wxTrackController';
export default {
  addressController,
  analystController,
  appAuthController,
  appConfigController,
  appCourseController,
  appUserController,
  articleController,
  articleCourseController,
  authController,
  cdAdviserController,
  chatDialogController,
  chatRoomController,
  chatRoomQaController,
  chatStreamMsgController,
  checkInController,
  clsController,
  contentController,
  convertController,
  couponController,
  couponPlanController,
  courseCatalogController,
  courseController,
  customerComplaintController,
  customerStrategyController,
  customerTrackController,
  ddOrderController,
  delayCouponController,
  eSignController,
  giftCouponController,
  giftGoodController,
  giftIntroduceController,
  invoiceController,
  kfController,
  liveRoomController,
  newEvaluationController,
  newsController,
  noticeSubController,
  orderController,
  orderPointController,
  ossController,
  paymentController,
  pointActivityController,
  promotionResourceController,
  promotionServiceController,
  promotionStockController,
  promotionVideoController,
  pubController,
  pubTeamController,
  raCustomerController,
  recommendStockController,
  rewardController,
  shortVideoController,
  signController,
  skuController,
  smsController,
  softwarePackageController,
  stockAiDiagnoseController,
  stockCaseController,
  stockCaseNewController,
  stockInfoController,
  stockScoreController,
  strategyApplyController,
  strategyBackTestController,
  strategyController,
  strategyCouponController,
  strategyOrderLinkController,
  strategySimulateController,
  strategySimulationBackTestController,
  strategyStockController,
  streamController,
  surveyController,
  teamVideoController,
  userController,
  vipCouponController,
  vipNoticeController,
  vodController,
  webOssConfigController,
  weimobController,
  workWxController,
  wxController,
  wxMaController,
  wxMaNewController,
  wxOauth2Controller,
  wxTrackController,
};
